import { render, staticRenderFns } from "./base-empty-state.vue?vue&type=template&id=298cacc6&"
import script from "./base-empty-state.vue?vue&type=script&lang=js&"
export * from "./base-empty-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports